<template>
  <ul class="tag-selector">
    <div class="tag-selector-input d-flex flex-row mb-2">
      <input
        classtype="text"
        class="w-100 form-control"
        placeholder="Enter a tag name.."
        v-model="tagSearchTerm"
      />
    </div>
    <li class="tag-item my-1 mr-1 position-relative" v-for="tag in filteredTags">
      <button
        type="button"
        @click="toggleTag(tag.id)"
        :class="{
          'btn-primary': selectedTags.includes(tag.id),
          btn: true,
          'btn-sm': true,
          'btn-secondary': !selectedTags.includes(tag.id)
        }"
      >
        {{ tag.truncatedTitle }}
        <span class="btn btn-secondary full-title">{{tag.title}}</span>
        <i class="material-icons">cancel</i>
      </button>
    </li>
  </ul>
</template>

<script>
import TagObject from "../objects/TagObject";
export default {
  name: "TagSelector",
  data: function() {
    return {
      tagSearchTerm: "",
      allTags: [],
      selectedTags: []
    };
  },

  computed: {
    filteredTags() {
      return this.allTags.filter(tag => {
        if (!this.tagSearchTerm) {
          return this.selectedTags.includes(tag.id);
        } else {
          return (
            tag.title.toLowerCase().indexOf(this.tagSearchTerm.toLowerCase()) >
              -1 || this.selectedTags.includes(tag.id)
          );
        }
      });
    }
  },
  props: {
    availableTags: Function,
    startingTags: Function
  },
  methods: {
    toggleTag(tag) {
      for (let i = 0; i < this.selectedTags.length; i++) {
        if (tag === this.selectedTags[i]) {
          this.selectedTags.splice(i, 1);
          this.$emit("tag-selection-updated", this.selectedTags);
          return;
        }
      }
      this.selectedTags.push(tag);
      this.$emit("tag-selection-updated", this.selectedTags);
      this.tagSearchTerm = "";
    }
  },
  beforeMount() {
    if (this.startingTags) {
      this.startingTags().then(data => {
        if (!data.tags) return; // TODO:

        for (let i = 0; i < data.tags.length; i++) {
          this.selectedTags.push(data.tags[i].id);
        }
      });
    }

    this.availableTags().then(data => {
      data.forEach(tag => {
        this.allTags.push(new TagObject(tag));
      });
    });
  }
};
</script>

<style scoped>
.tag-selector {
  margin: 0;
  padding: 0;
}
.tag-selector li {
  display: inline-block;
}

.tag-selector i {
  color: #ffffff;
  font-size: 16px;
  vertical-align: middle;
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .tag-selector {
    display: flex;
    flex-wrap: wrap;
  }

  .tag-selector li {
    flex-grow: 1;
    min-width: 20%;
  }

  .tag-selector li .btn {
    width: 100%;
    min-height: 75px;
    max-height: 75px;
  }

  .tag-selector-input {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .breadcrumbs-container ul {
    min-width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
  }
  .tag-selector-input {
    width: 100%;
  }
}

.tag-selector li button span.full-title {
  position: absolute;
  z-index: 5;
  top: 0;
  right: 0;
  display: none;
  opacity: 0.9;
  transform: translate(+90%, -90%);
  font-size: 0.875rem;
}

.tag-selector li button:hover span.full-title {
  display: block;
}
</style>
